module.exports = __webpack_public_path__ + "static/img/travelport.06bbab36.png";